var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutcomes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outcomes & Progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-line-up-solid",
    d: "M3,33.5a1.5,1.5,0,1,0-3,0V49.25A3.749,3.749,0,0,0,3.75,53H22.5a1.5,1.5,0,1,0,0-3H3.75A.752.752,0,0,1,3,49.25ZM20.578,43.578a1.126,1.126,0,0,0,1.922-.8V37.625A1.122,1.122,0,0,0,21.375,36.5H16.214a1.126,1.126,0,0,0-.8,1.922l1.519,1.519L14.25,42.627l-3.441-3.441a1.5,1.5,0,0,0-2.123,0l-3.75,3.75a1.5,1.5,0,1,0,2.123,2.123L9.75,42.373l3.441,3.441a1.5,1.5,0,0,0,2.123,0l3.75-3.75Z",
    transform: "translate(0 -32)",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomes);
export default __webpack_public_path__ + "static/media/outcomes.d3d617defca5f0adcf12fb94fbb109a8.svg";
export { ForwardRef as ReactComponent };